import { format, isValid } from 'date-fns';
import _ from 'lodash';

export class UserOvpJobCondition {
    /** @type {string} */
    _id = '';

    /** @type {User} */
    user = '';

    /** @type {Company} */
    company = '';

    /** @type {string} */
    companyOvpJobCondition = '';

    /** @type {Date} */
    nextInspectionDate = null;

    /** @type {boolean} */
    waitingForApproval = false;

    /** @type {string} */
    doctorsComment = '';

    /** @type {boolean} */
    isDeleted = false;

    /** @type {string} */
    formatedPeriod = '';

    /** @type {Object} */
    formatedDocData = {};

    /**
     * @param {Object} obj
     * @returns {UserOvpJobCondition}
     */
    static fromArray(obj) {

        const clonedObj = _.cloneDeep(obj);
       
        if (clonedObj.nextInspectionDate && isValid(new Date(clonedObj.nextInspectionDate))) {
            clonedObj.nextInspectionDate = format(new Date(clonedObj.nextInspectionDate), 'dd.MM.yyyy');
        }

        if (clonedObj.ovpJobCondition && clonedObj.ovpJobCondition.period) {
            const format = +clonedObj.ovpJobCondition.period === 1 ? `ā` : `os`;

            clonedObj.formatedPeriod = `1x${clonedObj.ovpJobCondition.period} gad${format}`;
        }

        if (clonedObj.formatedPeriod.length) {
            //Commenting out format as there was no need to show nextInspection date in generated document
            clonedObj.formatedDocData = {
                id: clonedObj._id,
                title: clonedObj.ovpJobCondition.globalOvpJobCondition.name,
                date: '',//format(add(new Date(), {years: clonedObj.ovpJobCondition.period}), 'dd.MM.yyyy');
                period: clonedObj.formatedPeriod,
                isSpecial: clonedObj.ovpJobCondition.isSpecial,
            };
        }

        return Object.assign(new this, clonedObj || {});
    }
}